export const DEDUCTION_SETUP_SECTIONS = [
  "deduction-categories",
  "types-subtypes",
  "reason-code",
] as const;

export type DeductionSetupSection = (typeof DEDUCTION_SETUP_SECTIONS)[number];

export function isDeductionSetupSection(
  value: string | undefined,
): value is DeductionSetupSection {
  return (
    typeof value === "string" &&
    (DEDUCTION_SETUP_SECTIONS as readonly string[]).includes(value)
  );
}

export function isImplementedDeductionSetupSection(
  value: string | undefined,
): value is DeductionSetupSection {
  return isDeductionSetupSection(value);
}
